import { render, staticRenderFns } from "./AboutCompany.vue?vue&type=template&id=634b1ae5&scoped=true&"
import script from "./AboutCompany.vue?vue&type=script&lang=js&"
export * from "./AboutCompany.vue?vue&type=script&lang=js&"
import style0 from "./AboutCompany.vue?vue&type=style&index=0&id=634b1ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b1ae5",
  null
  
)

export default component.exports